var render, staticRenderFns
import script from "./classxi_student.vue?vue&type=script&lang=js&"
export * from "./classxi_student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./classxi_student.vue?vue&type=custom&index=0&blockType=div&class=tab-pane%20fade%20show%20active&role=tabpanel&aria-labelledby=basicdetails-tab"
if (typeof block0 === 'function') block0(component)
import block1 from "./classxi_student.vue?vue&type=custom&index=1&blockType=div&class=tab-pane%20fade&role=tabpanel&aria-labelledby=parents_tab-tab"
if (typeof block1 === 'function') block1(component)
import block2 from "./classxi_student.vue?vue&type=custom&index=2&blockType=div&class=tab-pane&aria-labelledby=roles-tab"
if (typeof block2 === 'function') block2(component)
import block3 from "./classxi_student.vue?vue&type=custom&index=3&blockType=div&class=tab-pane&aria-labelledby=programmes-tab"
if (typeof block3 === 'function') block3(component)

export default component.exports